import {Image, Modal} from 'antd';
import PropTypes from 'prop-types';

const ProductDetailScreen = ({viewModal, setViewModal}) => {
  const images = Array.isArray(viewModal?.record?.imageUrl)
    ? viewModal.record.imageUrl
    : [viewModal?.record?.imageUrl];

  return (
    <div>
      {viewModal?.record && (
        <Modal
          title={'Product Details'}
          open={viewModal.visible}
          footer={null}
          width={950}
          onCancel={() => setViewModal({visible: false, record: null})}
        >
          <div className={'grid lg:grid-cols-2 gap-8'}>
            <div>
              <div
                className={`grid
                  grid-cols-2
                  sm:grid-cols-3
                  md:grid-cols-3
                  lg:grid-cols-2
                  gap-4
                  justify-items-center`}
              >
                {images.map((img, idx) => (
                  <div
                    key={idx}
                    className={`bg-gray-100
                      p-3
                      rounded-xl
                      flex
                      items-center
                      justify-center
                      w-full`}
                  >
                    <Image
                      src={img}
                      alt={`product-${idx}`}
                      preview={true}
                      style={{
                        height: 180,
                        width: 180,
                        objectFit: 'contain',
                      }}
                    />
                  </div>
                ))}
              </div>
            </div>

            <div className={'space-y-5'}>

              <div>
                <h2 className={'text-2xl font-semibold'}>
                  {viewModal.record.productName}
                </h2>

                <p className={'text-gray-500 text-sm mt-1'}>
                  {viewModal.record.description}
                </p>
              </div>

              <div className={'grid grid-cols-2 gap-y-2 text-gray-700'}>
                <Info label={'Category'} value={viewModal.record.jewelryType} />

                <Info
                  label={'Product Type'}
                  value={viewModal.record.productType}
                />

                <Info
                  label={'Gross Weight'}
                  value={viewModal.record.grossWeight}
                />

                <Info label={'Net Weight'} value={viewModal.record.netWeight} />
              </div>

              {viewModal.record.size?.length > 0 && (
                <div className={'text-xl font-semibold text-primary-900'}>
                  Starting from ₹ {viewModal.record.size[0]?.price}
                </div>
              )}

              {viewModal.record.size?.length > 0 && (
                <div className={'border rounded-xl p-4 bg-gray-50'}>
                  <h3 className={'font-semibold mb-3'}>Variants</h3>

                  {viewModal.record.size.map((item, idx) => (
                    <div
                      key={idx}
                      className={`flex
                        justify-between
                        items-center
                        bg-white
                        rounded-lg
                        px-4
                        py-3
                        mb-2
                        shadow-sm`}
                    >
                      {/* size */}

                      <div>
                        <div className={'text-xs text-gray-500'}>Size</div>

                        <div className={'font-semibold'}>
                          {item.size || '-'}
                        </div>
                      </div>

                      <div>
                        <div className={'text-xs text-gray-500'}>Price</div>

                        <div className={'font-semibold text-primary-900'}>
                          ₹ {item.price || 0}
                        </div>
                      </div>

                      <div>
                        <div className={'text-xs text-gray-500'}>Stock</div>

                        <div
                          className={
                            item.quantity > 0
                              ? 'font-medium text-green-600'
                              : 'font-medium text-red-500'
                          }
                        >
                          {item.quantity > 0
                            ? `${item.quantity} left`
                            : 'Out of stock'}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {viewModal.record.description && (
              <div className={'lg:col-span-2 border rounded-xl p-5 bg-gray-50'}>
                <h3 className={'font-semibold mb-2 text-lg'}>Description</h3>

                <p className={'text-gray-600 leading-relaxed'}>
                  {viewModal.record.description}
                </p>
              </div>
            )}
          </div>
        </Modal>
      )}
    </div>
  );
};

const Info = ({label, value}) => (
  <div>
    <span className={'font-medium'}>{label}:</span>{' '}
    <span className={'text-gray-600'}>{value || '-'}</span>
  </div>
);

Info.propTypes = {
  label: PropTypes.string.isRequired,

  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.node,
  ]),
};

ProductDetailScreen.propTypes = {
  viewModal: PropTypes.shape({
    visible: PropTypes.bool.isRequired,

    record: PropTypes.object,
  }).isRequired,

  setViewModal: PropTypes.func.isRequired,
};

export default ProductDetailScreen;
